export const COINS = ["AAPLB", "USDT", "BNB"];

export const COIN_META = {
  AAPLB: { dec: 2, label: "AAPLB", subtitle: "BUTTERFLY" },
  USDT: { dec: 2, label: "USDT", subtitle: "TETHER" },
  BNB: { dec: 4, label: "BNB", subtitle: "BINANCE" },
};

export function decOf(coin) {
  return (COIN_META[coin] || COIN_META.AAPLB).dec;
}

export function fmtCoin(value, coin) {
  return Number(value).toFixed(decOf(coin));
}

/** 第 n 张价格（n 从 1 起） */
export function unitPrice(pricing, n) {
  if (pricing.mode === "fixed") return pricing.fixed;
  const s = pricing.step || { start: 0, inc: 0 };
  return s.start + (n - 1) * s.inc;
}

/** 从当前已售 sold 张起，购买 q 张的总价 */
export function batchTotal(pricing, q, sold) {
  if (pricing.mode === "fixed") return q * pricing.fixed;
  const s = pricing.step || { start: 0, inc: 0 };
  let sum = 0;
  for (let i = 1; i <= q; i += 1) {
    sum += s.start + (sold + i - 1) * s.inc;
  }
  return sum;
}

export function calcTotalAt(pricing, from, to) {
  if (pricing.mode === "fixed") return pricing.fixed * (to - from);
  let sum = 0;
  for (let i = from + 1; i <= to; i += 1) {
    sum += unitPrice(pricing, i);
  }
  return sum;
}

export function pricingTag(pricing, tr) {
  return pricing.mode === "fixed" ? tr("mode_fixed") : tr("mode_step");
}

export function pricingDescText(pricing, tr, fmt) {
  const coin = pricing.coin || "AAPLB";
  const mode = pricingTag(pricing, tr);
  if (pricing.mode === "step") {
    const s = pricing.step || { start: 1, inc: 0.1 };
    return `${mode} · ${coin} ${fmtCoin(s.start, coin)} +${fmtCoin(s.inc, coin)}/${tr("stat2u")}`;
  }
  return `${mode} · ${coin} ${fmtCoin(pricing.fixed || 1, coin)}/${tr("stat2u")}`;
}

export function projectPricing(project) {
  return {
    coin: project.coin,
    mode: project.mode,
    fixed: project.fixed,
    step: project.step,
  };
}

export function defaultPriceForCoin(coin, mode) {
  if (mode === "step") {
    if (coin === "AAPLB") return { start: 1, inc: 0.1 };
    if (coin === "USDT") return { start: 0.6, inc: 0.06 };
    return { start: 0.002, inc: 0.0002 };
  }
  if (coin === "AAPLB") return 1;
  if (coin === "USDT") return 0.6;
  return 0.002;
}
